import { gaps, paddings } from '@ohgoodlord/design-system'
import styled from 'styled-components'

export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  border: 1px solid #55616b;
  border-radius: 5px;
  padding: 14px;
  display: flex;
  align-items: center;

  & > select {
    width: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    height: 100%;
  }
`

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  border: 1px solid #55616b;
  border-radius: 5px;
  padding: 14px;
  display: flex;
  align-items: center;

  & > input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 16px;
    height: 100%;
  }
`
interface InputLabelProps {
  $hasAsterix?: boolean
}

export const InputLabel = styled.label<InputLabelProps>`
  height: 29px;
  position: absolute;
  top: -16%;
  left: 3%;
  background-color: white;
  padding: 0 5px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  ${({ $hasAsterix }) => !$hasAsterix && `& > span { margin-right: 7px; }`}
`

export const Asterix = styled.span`
  position: relative;
  color: red;
  margin-left: 4px;
`

export const StyledContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${gaps.l};
  padding-bottom: ${paddings.l};
  overflow-y: scroll;
`

export const FormWrapper = styled.form`
  height: 100%;
  overflow-y: hidden;
`

export const StyledDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${gaps.l};
  justify-content: center;
  align-items: flex-start;
  padding: 0 20px;
`
